import React from 'react';
import PropTypes from 'prop-types';

import FFBase from './ff-base';
import withTranslate from '../../hoc/with-translate';
import styles from './ff-desktop.scss';

const classNames = require('classnames');

class FFDesktop extends FFBase {
  render() {
    return (
      <div>
        <div className={classNames(styles.wrapper, 'ma-box', 'ma-box-border')}>
          <div data-hook="ff-content" className={styles.container}>
            <h2 data-hook="ff-title" className={classNames(styles.title, 'ma-ff-title-font', 'ma-title-color')}>
              {this.props.t(`ff.title.${this.props.pageType}`)}
            </h2>
            <div className="ma-ff-dividers" />
            {super.renderAnimatedContent()}
          </div>
        </div>
        <div className={styles.footerFiller} />
      </div>
    );
  }
}

FFDesktop.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslate(FFDesktop);
